export enum ELEMENT_ID {
  APP_BAR = 'app-nav-bar',
}

export default ELEMENT_ID;
